module.exports = __webpack_public_path__ + "static/7-86217664c8403605acd86f0e345274e0.jpg";